import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react'
import { useStore } from '@contexts/store'
import { useCurrencySwitcher } from '@hooks/use-currency-switcher'
import { singleCurrencyObj } from '@interfaces/currencies'
import { FaChevronDown } from 'react-icons/fa'

export default function CurrencySwitcher() {
  const { storeData: storeBaseData } = useStore()

  const { selectedCurrency, handleItemClick } = useCurrencySwitcher()

  return (
    <Box>
      <Menu>
        <MenuButton
          as={Button}
          bg="transparent"
          fontSize={{ base: 'sm', md: 'md' }}
          fontWeight="400"
          rightIcon={<FaChevronDown />}
          py="0"
        >
          <span
            className={`fi fi-${selectedCurrency?.currency?.nationality}`}
          ></span>{' '}
          {selectedCurrency?.currency?.code} -{' '}
          {selectedCurrency?.currency?.symbol}
        </MenuButton>
        <MenuList>
          {storeBaseData?.currencies?.map(
            (singleCurrency: singleCurrencyObj, i: any) => {
              return (
                <MenuItem
                  onClick={() => handleItemClick(singleCurrency.currency._id)}
                  key={singleCurrency.currency._id}
                  value={singleCurrency.currency._id}
                >
                  {`${singleCurrency.currency.code} - ${singleCurrency.currency.symbol}`}
                </MenuItem>
              )
            },
          )}
        </MenuList>
      </Menu>
    </Box>
  )
}
